import { BodyLargeTypography } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const StyledText = styled.p`
  ${BodyLargeTypography};
  margin-top: 0;
  margin-bottom: 2.5rem;
`
